<template>
    <div id="galleryViewer" @click="imgBgClicked">

                <img id="galleryViewerImg" :src="currentImage.src" :alt="currentImage.alt" />
            
            <div id="galleryViewerLeft" @click="viewerLeft"></div>
            <div id="galleryViewerRight" @click="viewerRight"></div>
            <div id="galleryViewerClose"><img src="images/gallery-close.png" alt="close" @click="viewerClose" /></div>
        
    </div>
</template>

<script>
export default {
    name: 'Viewer',
    props: [ 'currentImage' ],
    methods: {
        viewerLeft() {
            this.$emit('viewerLeft');
        },
        viewerRight() {
            this.$emit('viewerRight');
        },
        viewerClose() {
            this.$emit('viewerClose');
        },
        imgBgClicked(e) {
            window.console.log(e.target.id);
            if (e.target.id == 'galleryViewer') 
                this.$emit('viewerClose');
        }
    },
    mounted() {
        //window.console.log(this.currentImage);
    }
}
</script>

<style lang="less" scoped>
    #galleryViewer {
        background: rgba(#000, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0;
        height: 100%;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1050;
    }
	#galleryViewerOuter {
		display: table;
		height: 100%;
		width: 100%;
	}
	#galleryViewerInner {
		display: table-cell;
		height: 100%;
		text-align: center;
		width: 100%;
		vertical-align: middle;

	}
	#galleryViewerImg {
		max-width: 100%;
		width: 100%;
	}
	#galleryViewerLeft {
        background:  url(../../public/images/gallery-left.png) no-repeat center center;
        background-color: rgba(#000, 0.3);
		cursor: pointer;
		left: 10px;
		height: 100px;
		margin: -50px 0 0;
		opacity: 0.5;
		position: absolute;
		top: 50%;
        width: 100px;
        &:hover {
            opacity: 0.7;
        }
	}
	#galleryViewerRight {
        background:  url(../../public/images/gallery-right.png) no-repeat center center;
        background-color: rgba(#000, 0.3);
		cursor: pointer;
		height: 100px;
		margin: -50px 0 0;
		opacity: 0.5;
		position: absolute;
		right: 10px;
		text-align: right;
		top: 50%;
        width: 100px;
        &:hover {
            opacity: 0.7;
        }
	}
	#galleryViewerClose {
        background: #000;
		color: #fefefe;
		cursor: pointer;
		font-size: 7.143em;
        height: 40px;
        opacity: 0.5;
		position: absolute;
		right: 20px;
		text-align: center;
		top: 20px;
        width: 40px;
        &:hover {
            opacity: 1;
        }
	}

</style>